var map = {
	"./osmTagToNameMapping-cs.template.ts": [
		48590,
		8590
	],
	"./osmTagToNameMapping-cs.ts": [
		35356,
		5356
	],
	"./osmTagToNameMapping-de.template.ts": [
		19689,
		9689
	],
	"./osmTagToNameMapping-de.ts": [
		75101,
		5101
	],
	"./osmTagToNameMapping-en.ts": [
		78017,
		8017
	],
	"./osmTagToNameMapping-hu.template.ts": [
		57725,
		7725
	],
	"./osmTagToNameMapping-hu.ts": [
		9345,
		9345
	],
	"./osmTagToNameMapping-it.template.ts": [
		64023,
		4023
	],
	"./osmTagToNameMapping-it.ts": [
		74987,
		4987
	],
	"./osmTagToNameMapping-pl.template.ts": [
		2092,
		2092
	],
	"./osmTagToNameMapping-pl.ts": [
		89642,
		9642
	],
	"./osmTagToNameMapping-sk.template.ts": [
		37174,
		7174
	],
	"./osmTagToNameMapping-sk.ts": [
		228,
		228
	],
	"./osmTagToNameMapping-xx.template.ts": [
		69200,
		9200
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64712;
module.exports = webpackAsyncContext;